module.exports = __webpack_public_path__ + "static/EventInner-dda96a41e2c00c8115959faeb769d1be.jpg";